import EngagementSection from "@app/components/haulers-sections/engagement-section";
import EquippedSection from "@app/components/haulers-sections/equipped-section";
import FocusSection from "@app/components/haulers-sections/focus-section";
import JoinUsSection from "@app/components/haulers-sections/join-us-section";

const HaulersPage = () => (
  <div>
    <FocusSection />
    <EquippedSection />
    <EngagementSection />
    <JoinUsSection />
  </div>
);

export default HaulersPage;
